import React, { useEffect, useState } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
  Block,
  BlockBetween,
  BlockDes,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  LoadingComponent,
  PreviewCard,
  ReactDataTable,
} from "../../../components/Component";
import { PER_PAGE_ITEMS, TimesheetStatusType, showErrorToast } from "../../../utils";
import { scrollToTop } from "../../../utils/Functions";
import { isCheckToList, UserPermissionType } from "../../../services/permission/permission";
import { getTimesheetListingAPI } from "../timesheets/TimesheetData";
import { timesheetReportColumns } from "./TimesheetReportColumns";
import TimesheetReportFilter from "./TimesheetReportFilter";

const TimesheetReport = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [timesheetList, setTimesheetList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [branch, setBranch] = useState();
  const [branchId, setBranchId] = useState(null);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (!startDate || !endDate) return;
    loadTimesheetReport();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, startDate, endDate, branchId, searchText]);

  function loadTimesheetReport() {
    scrollToTop();
    setLoading(true);
    getTimesheetListingAPI(
      {
        pageInfo: {
          pageIndex: currentPage,
          itemsPerPage: PER_PAGE_ITEMS,
        },
        startDate,
        endDate,
        status: TimesheetStatusType.verified,
        branchId,
        search: searchText,
      },
      (data, error) => {
        if (error === null) {
          setTimesheetList(data?.detail || []);
          setTotalItems(data?.pageInfo?.totalItems ?? 0);
        } else {
          showErrorToast(error.message);
        }
        setLoading(false);
      },
    );
  }

  const handleBranchChange = (selected) => {
    const selectedBranchId = selected?.id > 0 ? selected.id : null;
    setBranch(selectedBranchId ? selected : null);
    setBranchId(selectedBranchId);
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  };

  const handleSearchChange = (value) => {
    setSearchText(value);
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  };

  const handleDatePickerChange = (newStartDate, newEndDate) => {
    if (newStartDate === startDate && newEndDate === endDate) return;
    setStartDate(newStartDate);
    setEndDate(newEndDate);
    if (currentPage !== 1) {
      setCurrentPage(1);
    }
  };

  return (
    <React.Fragment>
      <Head title="Timesheet" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween className="align-items-center flex-nowrap g-3">
            <BlockHeadContent>
              <BlockTitle page>Timesheet</BlockTitle>
              <BlockDes className="text-soft">
                <p>You have total {totalItems} verified timesheets</p>
              </BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <TimesheetReportFilter
                branch={branch}
                onBranchChange={handleBranchChange}
                searchText={searchText}
                onSearchChange={handleSearchChange}
                onRangeChange={handleDatePickerChange}
              />
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewCard>
            <ReactDataTable
              data={timesheetList}
              columns={timesheetReportColumns()}
              isAllowed={isCheckToList(UserPermissionType.report)}
              totalItemCount={totalItems}
              pagination
              pageNum={currentPage}
              onPageChanged={(page) => {
                setCurrentPage(page);
              }}
            />
          </PreviewCard>
        </Block>
      </Content>
      <LoadingComponent isLoading={loading} />
    </React.Fragment>
  );
};

export default TimesheetReport;
